import ReactMarkdown from "react-markdown";
import { useState, type ClipboardEvent } from "react";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import { sanitizePropertyDescriptionPaste } from "../../utils/propertyPlainTextSanitizer";
import {
  Container,
  Header,
  ModeButton,
  TextArea,
  Preview,
} from "./styles";

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
}

function readClipboardText(event: ClipboardEvent<HTMLTextAreaElement>): string {
  return sanitizePropertyDescriptionPaste(
    event.clipboardData.getData("text/plain"),
    event.clipboardData.getData("text/html")
  );
}

export function MarkdownEditor({ value, onChange }: MarkdownEditorProps) {
  const [mode, setMode] = useState<"edit" | "preview">("edit");

  function handlePaste(event: ClipboardEvent<HTMLTextAreaElement>) {
    event.preventDefault();

    const sanitized = readClipboardText(event);
    const textarea = event.currentTarget;
    const start = textarea.selectionStart ?? value.length;
    const end = textarea.selectionEnd ?? value.length;
    const nextValue = `${value.slice(0, start)}${sanitized}${value.slice(end)}`;

    onChange(nextValue);

    requestAnimationFrame(() => {
      const cursor = start + sanitized.length;
      textarea.selectionStart = cursor;
      textarea.selectionEnd = cursor;
    });
  }

  return (
    <Container>
      <Header>
        <ModeButton
          active={mode === "edit"}
          onClick={() => setMode("edit")}
        >
          Editar
        </ModeButton>

        <ModeButton
          active={mode === "preview"}
          onClick={() => setMode("preview")}
        >
          Preview
        </ModeButton>
      </Header>

      {mode === "edit" ? (
        <TextArea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onPaste={handlePaste}
        />
      ) : (
        <Preview>
          <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
            {value || "_Nada para visualizar..._"}
          </ReactMarkdown>
        </Preview>
      )}
    </Container>
  );
}
